import React from 'react';
import * as C from './styles';

export const TableCND = ({ children }) => {
  return (
    <C.Container>
      <C.Header>
        <tr>
          <th>Nome da CND</th>
          <th>Válido até</th>
          <th>PDF</th>
        </tr>
      </C.Header>
      <tbody>{children}</tbody>
    </C.Container>
  );
};
